/*
 * loading
 */
const loading = function() {

	const wrapper = $('.js-wrapper');

	wrapper.fadeIn(300, function() {
		$(this).addClass('is-loaded');
		$(this).trigger('load');
	}).css('display', 'flex');
}


/*
* on load
*/
$(window).on('load', function() {

	loading();
});
